export { default as withConfiguration } from '@components/hoc/withConfiguration/withConfiguration';


// WEBPACK FOOTER //
// ./src/components/hoc/withConfiguration/index.ts